import {CountdownTimer} from '@countdown-timer';
import {Button, OtpInput} from '@ds/components';
import {useEffect} from 'react';
import {useAppDispatch} from 'store';
import {loginWithNoPass} from 'store/slices/vendor-registration/thunk';

const OTP_COUNTDOWN_SECONDS = 120;

type OtpVerificationProps = {
  otp: string;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
  phoneNumber: string;
  countDown: number;
  setCountDown: React.Dispatch<React.SetStateAction<number>>;
};

const OtpVerification: React.FC<OtpVerificationProps> = ({
  otp,
  setOtp,
  phoneNumber,
  countDown,
  setCountDown
}: OtpVerificationProps) => {
  const dispatch = useAppDispatch();

  const resend = async () => {
    setOtp('');

    const formData = new FormData();
    formData.append('cellphone', phoneNumber);
    formData.append('optionalLoginToken', 'true');
    formData.append('captcha', '');

    await dispatch(loginWithNoPass(formData)).unwrap();
    setCountDown(OTP_COUNTDOWN_SECONDS);
  };

  useEffect(() => {
    setCountDown(OTP_COUNTDOWN_SECONDS);
  }, [setCountDown]);

  return (
    <div className="flex w-full flex-col gap-6">
      <p className="text-body-sm text-neutral-fg">
        کد ۶ رقمی به شماره {phoneNumber} ارسال شد. لطفا کد را اینجا وارد کنید.
      </p>

      <OtpInput size="md" length={6} value={otp} onChange={setOtp} />

      <div className="flex min-h-10 items-center justify-center gap-1.5 text-body-sm text-gray-07">
        {countDown > 0 ? (
          <>
            <span>درخواست دوباره کد تا</span>
            <CountdownTimer initialCounter={countDown} setCountDown={setCountDown} />
          </>
        ) : (
          <>
            <span>کد را دریافت نکردید؟</span>
            <Button variant="link" color="secondary" size="sm" onClick={resend}>
              ارسال دوباره کد
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default OtpVerification;
